import { LayoutCarousel } from "@/Components/Index";
import DataViewModal from "@/Components/Modal/ModalData/DataViewModal";
import useWindowsSize from "@/Hooks/useWindowsSize";
import React, { useState } from "react";
import { Link } from "react-router-dom";

import uno from "@/assets/img/products/detail/fullwidth/1.jpg";
import dos from "@/assets/img/products/detail/fullwidth/2.jpg";
import tres from "@/assets/img/products/detail/fullwidth/3.jpg";
import Skeleton from "react-loading-skeleton";

type PropsImages = {
  sourceImage?: string[];
  isLoading?: boolean;
};

const styles = {
  verticals: {
    opacity: "1",
    height: "210px",
    transform: "translate3d(0px, 0px, 0px)",
  },
  horizontals: {
    opacity: "1",
    //width: "100%",
    transform: "translate3d(0px, 0px, 0px)",
  },
  skeletonHorizontal: {
    opacity: "1",
    height: "60px",
    transform: "translate3d(0px, 0px, 0px)",
  },
};

const DataViewImage = ({ sourceImage, isLoading }: PropsImages) => {
  const { width } = useWindowsSize();
  const [contImage, setContImage] = useState<number>(0);
  const [open, setOpen] = useState<boolean>(false);
  //const sourceImage = [uno, dos, tres];

  const headdlerImage = (index: number) => {
    setContImage(index);
  };

  //e: React.MouseEvent<HTMLElement, MouseEvent>
  const headdleOpen = () => {
    setContImage(0);
    setOpen((prev) => !prev);
  };

  const headdleNext = () => {
    //setContImage((prev) => (prev + 1) % sourceImage.length);
    const totalImg = sourceImage?.length;
    const maxIndex = Math.min(contImage + 1, Number(totalImg) - 1);
    setContImage(maxIndex);
  };

  const headdlePrev = () => {
    const newIndex = Math.max(contImage - 1, 0);
    setContImage(newIndex);
  };

  return (
    <>
      <div className="ps-product__thumbnail" data-vertical="true">
        <figure>
          <div className="ps-wrapper">
            <div className="ps-product__gallery" data-arrow="true">
              {isLoading ? (
                <Skeleton height={260} />
              ) : (
                <>
                  <Link
                    to="#"
                    className="slick-arrow"
                    aria-disabled="false"
                    style={{}}
                    onClick={headdlePrev}>
                    <i className="fa fa-angle-left"></i>
                  </Link>
                  <LayoutCarousel
                    //navigation
                    sildesPerView={1}
                    sildesPerViewTwo={1}
                    reference={contImage}>
                    {sourceImage?.map((img, index) => (
                      <div className="item" key={index}>
                        <Link to={""} onClick={headdleOpen}>
                          <img src={img} alt={`slide-${index}`} />
                        </Link>
                      </div>
                    ))}
                  </LayoutCarousel>
                  <Link
                    to="#"
                    className="slick-arrow slick-disabled"
                    style={{}}
                    aria-disabled="true"
                    onClick={headdleNext}>
                    <i className="fa fa-angle-right"></i>
                  </Link>
                </>
              )}
            </div>
          </div>
        </figure>
        <div
          className={
            width >= 1200
              ? "ps-product__variants slick-initialized slick-slider slick-vertical"
              : "ps-product__variants slick-initialized slick-slider"
          }
          data-item="4"
          data-md="4"
          data-sm="4"
          data-arrow="false">
          <div
            className=""
            role="listbox"
            style={width >= 1200 ? styles.verticals : styles.horizontals}>
            {isLoading ? (
              <Skeleton
                style={width >= 1200 ? styles.verticals : styles.skeletonHorizontal}
              />
            ) : /* width >= 1200 ?  */
            width >= 1201 ? (
              <>
                {sourceImage?.slice(0, 3)?.map((img, index) => (
                  <div
                    className="item"
                    key={index}
                    onClick={() => headdlerImage(index)}>
                    <img src={img} alt={`thumbnail-${index}`} />
                  </div>
                ))}
                {Number(sourceImage?.length) > 3 && (
                  <div className="item">
                    <h3
                      className="p-3 d-flex align-items-center mx-auto my-auto text-danger"
                      onClick={headdleOpen}>
                      +4
                    </h3>
                  </div>
                )}
              </>
            ) : (
              <div className="slick-list draggable" aria-live="polite">
                <div className="p-2 d-flex w-100">
                  {sourceImage?.slice(0, 3)?.map((img, index) => (
                    <div
                      className="p-2 item"
                      key={index}
                      onClick={() => headdlerImage(index)}>
                      <img
                        className="rounded"
                        src={img}
                        alt={`thumbnail-${index}`}
                      />
                    </div>
                  ))}
                  {Number(sourceImage?.length) > 3 && (
                    <div className="p-2 item">
                      <h3
                        className="p-3 d-flex align-items-center mx-auto my-auto text-danger"
                        onClick={headdleOpen}>
                        +4
                      </h3>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {open && (
        <div className="lg-backdrop in" style={{ transitionDuration: "150ms" }}>
          <DataViewModal headdleOpen={headdleOpen} />
        </div>
      )}
    </>
  );
};

export default DataViewImage;
